import { createSelector } from 'reselect';

class HelpSelectors {
    static getFaqs = (state) => state.help.faqs;

    static getFaqsTransferring = (state) => state.help.faqsTransferring;

    static getVisibleTab = (state) => state.help.visibleTab;

    static getContacts = (state) => state.help.contacts;

    static getContactsTransferring = (state) => state.help.contactsTransferring;

    static getContactMessage = (state) => state.help.contactMessage;

    static getContactSubjectIndex = (state) => state.help.contactSubjectIndex;

    static getContactMessageTransferring = (state) =>
        state.help.contactMessageTransferring;

    static getContactMessageSent = (state) => state.help.contactMessageSent;

    static getContactSubject = createSelector(
        HelpSelectors.getContacts,
        HelpSelectors.getContactSubjectIndex,
        (contacts, index) => contacts[index].kind
    );

    static getHelpIsLoaded = createSelector(
        HelpSelectors.getFaqs,
        HelpSelectors.getFaqsTransferring,
        HelpSelectors.getContacts,
        HelpSelectors.getContactsTransferring,
        (faqs, faqsTransferring, contacts, contactsTransferring) =>
            faqs.length > 0 &&
            !faqsTransferring &&
            contacts.length > 0 &&
            !contactsTransferring
    );
}

export default HelpSelectors;



// WEBPACK FOOTER //
// ./app/selectors/help.js